import { Link } from "react-router-dom";
import { useBreadcrumbs } from "../context/BreadcrumbContext";

function Chevron() {
  return (
    <svg
      className="size-4 shrink-0 text-gray-300"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function Breadcrumbs() {
  const { trail } = useBreadcrumbs();

  if (trail.length < 3) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol role="list" className="flex flex-wrap items-center gap-y-1">
        {trail.map((item, index) => {
          const isFirst = index === 0;
          const isLast = index === trail.length - 1;
          return (
            <li key={`${index}-${item.label}`} className="flex items-center">
              {!isFirst && <Chevron />}
              {isLast || !item.to ? (
                <span
                  className={`${isFirst ? "" : "ml-1"} text-sm font-medium text-ink`}
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className={`${isFirst ? "" : "ml-1"} text-sm text-smoke hover:text-ink`}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
